import React from "react";
import { IconButton } from "@mui/material";
import { ValueChangedEvent } from "@shared/type/CommonType";
import SnHeader from "./SnHeader";
interface SnTabHeaderProps {
  onBtnAddClick?: (id: string) => void;
  onBtnDeleteClick?: (id: string) => void;
  body?: React.ReactNode;
  headerInfo?: any;
  onHeaderValueChanged?: (
    event: ValueChangedEvent
  ) => Record<string, any> | void;
  onBtnEtcClick?: (sender: string) => void;
  onHeaderEnter?: (sender: string, value: string) => void;
}

export function SnTabHeader({
  onBtnAddClick,
  onBtnDeleteClick,
  body,
  headerInfo,
  onHeaderValueChanged,
  onBtnEtcClick,
  onHeaderEnter,
}: SnTabHeaderProps) {
  return (
    <div>
      <div className="flex justify-end items-center">
        <div className="ml-2">{body}</div>
        <SnHeader
          headerInfo={headerInfo}
          onHeaderValueChanged={onHeaderValueChanged}
          onHeaderEnter={onHeaderEnter}
          onButtonClick={onBtnEtcClick}
        />
        {onBtnAddClick != null && (
          <div className="ml-2">
            <IconButton
              onClick={(e) => {
                // 그리드/탭 상위 컨테이너 클릭 이벤트로 버블링되면
                // onBtnAddClick 이 중복 호출되는 화면이 있어 전파를 차단한다.
                e.preventDefault();
                e.stopPropagation();
                onBtnAddClick != null && onBtnAddClick("addRow");
              }}
              sx={{
                backgroundImage: "url(/images/new_off.svg)", // 기본 상태 이미지
                backgroundSize: "cover", // 이미지 크기 맞추기
                width: 30, // 버튼 크기
                height: 30, // 버튼 크기
                "&:hover": {
                  backgroundImage: "url(/images/new_on.svg)", // hover 시 이미지
                  transform: "scale(1.2)", // hover 시 크기 확대
                  transition: "all 0.3s ease", // 부드러운 애니메이션
                },
              }}
            ></IconButton>
          </div>
        )}
        {onBtnDeleteClick != null && (
          <div className="ml-5 mr-4">
            <IconButton
              onClick={(e) => {
                // add 버튼과 동일하게 delete도 버블링을 차단해
                // 버튼 클릭 1회당 핸들러가 1회만 실행되도록 맞춘다.
                e.preventDefault();
                e.stopPropagation();
                onBtnDeleteClick != null && onBtnDeleteClick("deleteRow");
              }}
              sx={{
                backgroundImage: "url(/images/delete_off.svg)", // 기본 상태 이미지
                backgroundSize: "cover", // 이미지 크기 맞추기
                width: 25, // 버튼 크기
                height: 25, // 버튼 크기
                "&:hover": {
                  backgroundImage: "url(/images/delete_on.svg)", // hover 시 이미지
                  transform: "scale(1.2)", // hover 시 크기 확대
                  transition: "all 0.3s ease", // 부드러운 애니메이션
                },
              }}
            ></IconButton>
          </div>
        )}
      </div>
    </div>
  );
}

export default React.memo(SnTabHeader);
